import React from 'react';
import i18n from 'i18next';
import style from './style.less';
import { LINK_TEXT, getVipInfo, isVip, onVipLinkClick } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import classNames from 'classnames';
import { openPay } from '@src/js/common/ark-extensions/dc-components/pay';
import { getAidForReport } from '@tencent/txdocs-aid';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { QUICK_TOOL_AID_FEATURE, QUICK_TOOL_AID_POSITION } from '@src/slide/application/service/quick-tool-dialog-manager/core';


export function getVipLinkText(fromToolbar = false) {
    const isNotVip = !isVip();
    const aid = getAidForReport({
        feature: QUICK_TOOL_AID_FEATURE,
        position: fromToolbar ? QUICK_TOOL_AID_POSITION.TOOLBAR : QUICK_TOOL_AID_POSITION.RIGHT_MENU,
        apprec1: LINK_TEXT,
    });
    const reportParams = {
        opername: TDWOperationType.VIP_UPGRADE,
        module: TDWModuleType.LINK_TEXT,
        action: TDWActionType.SHOW,
        eventcode: `${TDWOperationType.VIP_UPGRADE}-${TDWModuleType.LINK_TEXT}-${TDWActionType.SHOW}`,
        ver5: getVipInfo(),
        ver6: QUICK_TOOL_AID_FEATURE,
        ver7: ActionType.QUICK_TOOL,
        ver8: aid,
        ver9: `pc_${fromToolbar ? QUICK_TOOL_AID_POSITION.TOOLBAR : QUICK_TOOL_AID_POSITION.RIGHT_MENU}`,
    };
    return (
        <div className={classNames({
            [style['tool-box-vip-title']]: true,
            [style[`tool-box-vip-title-${isNotVip ? 'no-' : ''}vip-bg`]]: true,
        })}>
            <div className={classNames({
                [style['tool-box-vip-title-icon']]: true,
                [style['hover-cursor']]: true,
            })} onClick={() => {
                onVipLinkClick(aid, reportParams, 'text', 'PPT-TOOLS');
            }}></div>
            <div className={classNames({
                [style['tool-box-vip-title-text']]: true,
                [style['hover-cursor']]: true,
            })} onClick={() => {
                onVipLinkClick(aid, reportParams, 'text', 'PPT-TOOLS');
            }}>{ i18n.t('会员专享功能') }</div>
            {
                isNotVip ? <div className={style['tool-box-vip-title-btn']} onClick={async (e) => {
                    e.stopPropagation();
                    openPay(aid);
                }}>{ i18n.t('开通会员') }</div> : null
            }
        </div>
    );
}

export function tdwReportForVipLinkText(fromToolbar = false) {
    const aid = getAidForReport({
        feature: QUICK_TOOL_AID_FEATURE,
        position: fromToolbar ? QUICK_TOOL_AID_POSITION.TOOLBAR : QUICK_TOOL_AID_POSITION.RIGHT_MENU,
        apprec1: LINK_TEXT,
    });
    tdw({
        opername: TDWOperationType.VIP_UPGRADE,
        module: TDWModuleType.LINK_TEXT,
        action: TDWActionType.SHOW,
        eventcode: `${TDWOperationType.VIP_UPGRADE}-${TDWModuleType.LINK_TEXT}-${TDWActionType.SHOW}`,
        ver5: getVipInfo(),
        ver6: QUICK_TOOL_AID_FEATURE,
        ver7: ActionType.QUICK_TOOL,
        ver8: aid,
        ver9: `pc_${fromToolbar ? QUICK_TOOL_AID_POSITION.TOOLBAR : QUICK_TOOL_AID_POSITION.RIGHT_MENU}`,
    });
}
